<template>
  <div class="gl-cell-container">
    <v-icon color="var(--v-resBlue-darken1)" class="collapse-icon-container" @click.stop="toggleCollapse" v-if="params.data.isCollapsible && !params.data.isCollapsed">mdi-chevron-down</v-icon>
    <v-icon color="var(--v-resBlue-darken1)" class="collapse-icon-container" @click.stop="toggleCollapse" v-if="params.data.isCollapsible && params.data.isCollapsed">mdi-chevron-right</v-icon>
    <v-icon class="calculator-container" @click.stop="openCalculator" v-if="!params.data.isHistorical && !params.data.isCollapsible && params.data.glAccountId">mdi-calculator</v-icon>
    <div class="working-row-container" v-if="params.data.isWorkingRow">
     <v-tooltip top max-width="400">
        <template v-slot:activator="{ on, attrs }">
          <div class="working-row-lock-icon" v-bind="attrs" v-on="on" @click.stop="toggleWorkingRowLock">
            <v-icon  small :class="isEffectivelyLocked ? 'locked' : 'unlocked'">{{ isEffectivelyLocked ? 'mdi-lock-outline' : 'mdi-lock-open-outline' }} </v-icon>
          </div>
        </template>
        <span>
          {{ params.data.isLocked ? 'This working row is locked. Requires Edit Locked GL Accounts permission to edit.' : 'Lock this working row to prevent changes' }}
        </span>
      </v-tooltip>

      <div class="working-row-title" :class="params.data.url ? 'clickable' : ''" @click="navigateToLink">
       
       {{params.data.label}}

        <v-tooltip bottom v-if="params.data.icon">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" small class="ml-2"> {{ params.data.icon }}</v-icon>
          </template>
          <span>{{ params.data.iconHoverText }}</span>
        </v-tooltip>
      </div>
    </div>

   
    <div v-else class="gl-title" :class="params.data.url ? 'clickable' : ''" @click="navigateToLink">
       {{ params.data.label }}
      <v-tooltip bottom v-if="params.data.icon">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" class="ml-3">{{params.data.icon}}</v-icon>
        </template>
        <span>{{params.data.iconHoverText}}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'GLTitleCell',
    components: {
     
    },
    props: {

    },
    data: function () {
    
    },
   computed: {
    isEffectivelyLocked() {
      return this.params.data.parentGLIsLocked || this.params.data.isLocked;},
    },
    methods: {
      navigateToLink(e) {
        if (this.params.data.url) {
          window.open(this.params.data.url, '_blank')
           e?.preventDefault?.();
           e?.stopImmediatePropagation?.();
        }
      },

    toggleWorkingRowLock() {
      if (this.params.toggleWorkingRowLock) {
        this.params.toggleWorkingRowLock(this.params.data);
      } else {
        console.error('toggleWorkingRowLock method not provided in cellRendererParams');
      }
    },
      openCalculator() {
        if (this.params.openCalculator) {this.params.openCalculator(this.params.data);}
      },
      toggleCollapse() {
        //toggle collapse state on container
        this.params.data.isCollapsed = !this.params.data.isCollapsed;
        //toggle collapse state on sub rows
      this.params.api.forEachNode(node => { if (node.data.glAccountId == this.params.data.glAccountId && (node.data.year === 0 || node.data.year == this.params.data.year) && node.data.isHistorical == this.params.data.isHistorical) { node.data.isCollapsed = this.params.data.isCollapsed; localStorage.setItem(`${this.params.data.glAccountId + node.data.year}-collapsed_subrow`, this.params.data.isCollapsed );}});
      //refresh view
      this.params.api.refreshInMemoryRowModel()
      this.params.api.refreshView()
    }
    }
  }
</script>

<style lang="scss" scoped>
  .gl-cell-container {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 36px;
   }

  .collapse-icon-container {
    position: absolute;
    left: 18px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }

  .calculator-container {
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    color: var(--v-resBlue-darken1);
    cursor: pointer;
  }

  .working-row-container {
    display: flex;
    align-items: center;
    margin-left: 32px;
    width: calc(100% - 32px);
    padding: 4px 0;
   }

  .working-row-lock-icon {
    flex-shrink: 0;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 4px;
    }

  .working-row-title {
    flex: 1;
    max-width: 160px;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    line-height: 1.2;
    font-size: 12px;
   }

  .gl-title {
    position: absolute;
    right: 10px;
    display: inline-block;
    font-size: 12px;
  }

  .locked {
   color: var(--v-resRed-darken2) !important;
   }

  .unlocked {
   color: var(--v-resGrey-darken2) !important;
  }

   .clickable:hover {
    color: var(--v-resBlue-darken1);
    text-decoration: underline;
    cursor: pointer; 
  }
</style>
